import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Row, Col, Alert } from "react-bootstrap";
import { meta } from "../../content_option";
import "../contact/style.css";
import "./style.css";

export const CoffeeChat = () => {
  const { i18n } = useTranslation();
  const language = (i18n.language || "en").split("-")[0];

  const [coffeeData, setCoffeeData] = useState({
    name: "",
    email: "",
    dates: [{ startTime: "", endTime: "", zoomOk: false }],
    topic: "",
    loading: false,
    show: false,
    alertmessage: "",
    variant: "",
  });

  const handleCoffeeChange = (e) => {
    setCoffeeData({ ...coffeeData, [e.target.name]: e.target.value });
  };

  const handleDateChange = (index, field, value) => {
    const newDates = [...coffeeData.dates];
    newDates[index] = { ...newDates[index], [field]: value };
    setCoffeeData({ ...coffeeData, dates: newDates });
  };

  const addDateOption = () => {
    setCoffeeData({ ...coffeeData, dates: [...coffeeData.dates, { startTime: "", endTime: "", zoomOk: false }] });
  };

  const removeDateOption = (index) => {
    setCoffeeData({ ...coffeeData, dates: coffeeData.dates.filter((_, i) => i !== index) });
  };

  const handleCoffeeSubmit = async (e) => {
    e.preventDefault();
    setCoffeeData((prev) => ({ ...prev, loading: true }));
    try {
      const formattedDates = coffeeData.dates
        .filter((d) => d.startTime)
        .map((d, i) => `Option ${i + 1}: ${d.startTime}${d.endTime ? ` ~ ${d.endTime}` : ""} ${d.zoomOk ? "(Zoom OK)" : "(In-person only)"}`)
        .join(" | ");

      const response = await fetch("https://formsubmit.co/ajax/449a6d74c17f90d802898ebf0ce00b12", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          _subject: "새로운 커피챗 요청이 도착했습니다! / New Coffee Chat Request",
          Name: coffeeData.name,
          Email: coffeeData.email,
          "Preferred Dates": formattedDates,
          "Topic/Purpose": coffeeData.topic,
        }),
      });

      if (response.ok) {
        setCoffeeData({
          loading: false,
          alertmessage: language === "ko" ? "커피챗 요청이 성공적으로 전송되었습니다!" : "Coffee chat request sent successfully!",
          variant: "success",
          show: true,
          name: "",
          email: "",
          dates: [{ startTime: "", endTime: "", zoomOk: false }],
          topic: "",
        });
      } else {
        throw new Error(language === "ko" ? "요청 전송에 실패했습니다." : "Failed to send request.");
      }
    } catch (error) {
      setCoffeeData((prev) => ({
        ...prev,
        loading: false,
        alertmessage: `${language === "ko" ? "전송 실패" : "Failed"}: ${error.message}`,
        variant: "danger",
        show: true,
      }));
      document.getElementsByClassName("coffee_alert")[0]?.scrollIntoView();
    }
  };

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Coffee Chat | {meta.title}</title>
      </Helmet>
      <div className="join-body">
        <h1 className="join-heading">Coffee Chat with Us</h1>
        <p className="join-sub">
          {language === "ko"
            ? "편하게 이야기 나눠요. 가능한 시간을 알려주시면 일정을 맞춰보겠습니다."
            : "Let's talk. Tell us when you're free and we'll find a time."}
        </p>

        <Alert
          variant={coffeeData.variant}
          className={`rounded-0 coffee_alert ${coffeeData.show ? "d-block" : "d-none"}`}
          onClose={() => setCoffeeData({ ...coffeeData, show: false })}
          dismissible
        >
          <p className="my-0">{coffeeData.alertmessage}</p>
        </Alert>

        <Row className="sec_sp">
          <Col lg="5" className="mb-5">
            <h3 className="color_sec py-4">Check My Schedule</h3>
            <p>
              {language === "ko"
                ? "아래 캘린더에서 일정을 확인하시고, 가능한 시간에 맞춰 커피챗을 요청해주세요."
                : "Check the schedule below and request a coffee chat at an available time."}
            </p>
            <div className="calendar-wrapper mt-4" style={{ borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 15px rgba(0,0,0,0.1)" }}>
              <iframe
                src="https://calendar.google.com/calendar/embed?height=400&wkst=1&bgcolor=%23ffffff&ctz=Asia%2FSeoul&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=0&showCalendars=0&showTz=0&mode=WEEK&src=bW9pY2ZoYzNnbjNmcGIycGU1ZGk1aXNoa2tAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&color=%23039BE5"
                style={{ border: 0 }}
                width="100%"
                height="400"
                frameBorder="0"
                scrolling="no"
                title="Google Calendar Schedule"
              ></iframe>
            </div>
          </Col>
          <Col lg="7" className="d-flex align-items-center">
            <form onSubmit={handleCoffeeSubmit} className="contact__form w-100">
              <Row>
                <Col lg="6" className="form-group">
                  <input className="form-control" name="name" placeholder="Full Name" value={coffeeData.name || ""} type="text" required onChange={handleCoffeeChange} />
                </Col>
                <Col lg="6" className="form-group">
                  <input className="form-control rounded-0" name="email" placeholder="Email" type="email" value={coffeeData.email || ""} required onChange={handleCoffeeChange} />
                </Col>
              </Row>
              <p className="text-muted mb-2" style={{ fontSize: "0.82rem", letterSpacing: "0.04em", textTransform: "uppercase" }}>Preferred Date &amp; Time</p>
              {coffeeData.dates.map((dateObj, index) => (
                <div key={index} className="coffee-slot mb-4">
                  <Row className="align-items-stretch g-2">
                    <Col xs="12" lg={index === 0 ? "6" : "5"} className="form-group mb-0">
                      <label className="coffee-slot-label">Start</label>
                      <input
                        className="form-control rounded-0"
                        type="datetime-local"
                        value={dateObj.startTime}
                        required={index === 0}
                        step="600"
                        onChange={(e) => handleDateChange(index, "startTime", e.target.value)}
                        style={{ cursor: "pointer" }}
                      />
                    </Col>
                    <Col xs="12" lg="6" className="form-group mb-0">
                      <label className="coffee-slot-label">End</label>
                      <input
                        className="form-control rounded-0"
                        type="datetime-local"
                        value={dateObj.endTime}
                        step="600"
                        min={dateObj.startTime || undefined}
                        onChange={(e) => handleDateChange(index, "endTime", e.target.value)}
                        style={{ cursor: "pointer" }}
                      />
                    </Col>
                    {index > 0 && (
                      <Col xs="auto" className="d-flex align-items-end mb-0">
                        <button type="button" className="btn btn-outline-danger" onClick={() => removeDateOption(index)} style={{ height: "42px", lineHeight: 1, padding: "0 12px" }}>
                          ✕
                        </button>
                      </Col>
                    )}
                  </Row>
                  <div className="form-check mt-2 ms-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`zoom_${index}`}
                      checked={dateObj.zoomOk}
                      onChange={(e) => handleDateChange(index, "zoomOk", e.target.checked)}
                      style={{ cursor: "pointer" }}
                    />
                    <label className="form-check-label text-muted" htmlFor={`zoom_${index}`} style={{ fontSize: "0.83rem", cursor: "pointer" }}>
                      Zoom OK if in-person unavailable
                    </label>
                  </div>
                </div>
              ))}
              <Row className="mb-4">
                <Col lg="12">
                  <button type="button" className="btn btn-outline-secondary btn-sm" onClick={addDateOption} style={{ fontSize: "0.82rem", letterSpacing: "0.02em" }}>
                    + Add another time option
                  </button>
                </Col>
              </Row>
              <textarea
                className="form-control rounded-0"
                name="topic"
                placeholder="Tell us more about you, and what you want to know..."
                rows="4"
                value={coffeeData.topic || ""}
                onChange={handleCoffeeChange}
                required
              ></textarea>
              <br />
              <Row>
                <Col lg="12" className="form-group">
                  <button className="btn ac_btn" type="submit" disabled={coffeeData.loading}>
                    {coffeeData.loading ? "Sending..." : "Request Coffee Chat"}
                  </button>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </div>
      <div className={coffeeData.loading ? "loading-bar" : "d-none"}></div>
    </HelmetProvider>
  );
};
